import React from 'react'
import {FileDrop} from 'react-file-drop'
import { MoonLoader } from 'react-spinners'

import './style.scss'

const Index = ({file, parseData, handleFileDrop}) => {

    const renderRows = () => {
        if(parseData && parseData.meta && parseData.meta.fields && parseData.meta.fields.length){
            return parseData.meta.fields.length
        } else {
            return null
        }
    }

    return(
        <div className="csv-drop-container">
            <FileDrop onDrop={handleFileDrop}>
            {file ?
                <div className="selected-file-container">
                    <h1 className="file-icon"><i class="fas fa-file-csv"></i></h1>
                    <h3 className="file-name">{file && file.name ? file.name:"Ikke tilgjengelig"}</h3>
                    <p className="file-size">{`${renderRows() ? `${renderRows()} rader`:`Ingen rader`}`}</p>
                 </div>
                :
                <div className="no-csv-container">
                    <h3 className="upload-csv-title">Dra en fil hit for å laste opp.</h3>
                    <p className="upload-csv-description">Kun av filtype .csv</p>
                </div>  
            }
            </FileDrop>
        </div>
    )
}

export default Index